import { login, logout, getInfo } from '@/api/login'
import { getToken, setToken, removeToken } from '@/utils/auth'
import EnvBase from '@/env'
import qnpermission from '@/vendor/qnbar/qnpermission'

let userInfo = null
try {
    userInfo = JSON.parse(localStorage.getItem('user_data'))
} catch (e) {
    throw Error('user_data解析出错')
}

const user = {
    state: {
        token: getToken(),
        name: '',
        avatar: '',
        roles: [],
        agent_guid: '',
        agent_name: '',
        guid: '',
        official_staff_guid: '',
        official_staff_name: '',
        user_type: '',
        permissions: []
    },

    mutations: {
        SET_TOKEN: (state, token) => {
            state.token = token
        },
        SET_NAME: (state, name) => {
            state.name = name
        },
        SET_AVATAR: (state, avatar) => {
            state.avatar = avatar
        },
        SET_ROLES: (state, roles) => {
            state.roles = roles
        },
        SET_DATA: (state, data) => {
            Object.assign(state, data)
        },
        SET_PERMISSIONS: (state, permissions) => {
            state.permissions = permissions
        }
    },

    actions: {
        // 登录 (保持现状，项目主要走 SSO)
        Login({ commit }, userInfo) {
            const username = userInfo.username.trim()
            return new Promise((resolve, reject) => {
                login(username, userInfo.password).then(response => {
                    const data = response.data
                    setToken(data.token)
                    commit('SET_TOKEN', data.token)
                    resolve()
                }).catch(error => {
                    reject(error)
                })
            })
        },

        // 获取用户信息
        GetInfo({ commit, state }) {
            return new Promise((resolve, reject) => {
                const PT = EnvBase.PT
                getInfo(state.token).then(response => {
                    const data = response.data
                    if (!data) {
                        reject('获取用户信息失败')
                        return
                    }
                    // 对齐业务字段：agent_name -> name, agent_guid -> guid
                    commit('SET_DATA', data)
                    commit('SET_NAME', data.agent_name || data.name || '')
                    commit('SET_AVATAR', data.avatar || '')

                    // 获取全量权限 (每次都从接口拉取，不缓存)
                    const PermissionChecker = new qnpermission.PermissionChecker()
                    const localSess = PT.qnlogin.getLocalSess()
                    PermissionChecker.queryAllPermissions(PT.apiClient, PT.config.platformUsagespace, localSess, (pMsg) => {
                        const permissions = pMsg.data || []
                        commit('SET_PERMISSIONS', permissions)
                        commit('SET_ROLES', ['admin'])
                        // queryAllPermissions 内部会将 blocked 重新设为 true，需释放阻塞队列
                        PT.apiClient.resumeQuery()
                        resolve(response)
                    }, (pMsg) => {
                        commit('SET_ROLES', ['admin'])
                        PT.apiClient.resumeQuery()
                        resolve(response)
                    })
                }).catch(error => {
                    reject(error)
                })
            })
        },

        // 登出
        LogOut({ commit, state }) {
            return new Promise((resolve, reject) => {
                logout(state.token).then(() => {
                    commit('SET_TOKEN', '')
                    commit('SET_ROLES', [])
                    removeToken()
                    resolve()
                }).catch(error => {
                    reject(error)
                })
            })
        },

        // 前端 登出
        FedLogOut({ commit }) {
            return new Promise(resolve => {
                commit('SET_TOKEN', '')
                removeToken()
                resolve()
            })
        }
    }
}

export default user



// WEBPACK FOOTER //
// ./src/store/modules/user.js